import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

import Swal from 'sweetalert2';

import { AgendamentoService } from '@app/shared/services';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { GerenciarAgendamentoService } from '@app/shared/services/gerenciar-agendamento.service';

import { Agendamento, Loading } from '@app/shared/models';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-meus-agendamentos',
  templateUrl: './meus-agendamentos.component.html',
  styleUrls: ['./meus-agendamentos.component.scss']
})
export class MeusAgendamentosComponent implements OnChanges {

  @Input('censo') censo: any;
  @Input('usuario') usuario: any;

  cliente = environment.cliente;
  carregar = new Loading();
  agendamentos: Agendamento[] = [];

  constructor(
    private agendamentoService: AgendamentoService,
    private gerenciarAgendamentoService: GerenciarAgendamentoService,
    private router: Router,
    private mensagemService: MensagemService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.gerenciarAgendamentoService.status === 'AGENDAMENTOS') {
      this.buscarAgendamentos(this.usuario.cpf);
    }
  }

  buscarAgendamentos(cpf: string): any {
    this.agendamentoService.buscarAgendamentos(this.censo.id, cpf, this.carregar).subscribe(data => {
      this.agendamentos = data;
      this.agendamentos.forEach(a => {
        a.podeCancelar = ['AUSENTE', 'AGENDADO', 'EM_ANDAMENTO'].includes(a.status);
        a.podeEditar = ['AUSENTE', 'AGENDADO', 'EM_ANDAMENTO'].includes(a.status);
        a.podeImprimir = ['CONCLUIDO', 'AGENDADO', 'EM_ANDAMENTO'].includes(a.status);
      });
    });
  }

  editar(agendamento: Agendamento): any {
    this.mensagemService.avisoMensagemCondicional('Deseja alterar o agendamento?', 'Atenção', 'warning').then((result) => {
      if (result.isConfirmed) {
        this.gerenciarAgendamentoService.agendamento = agendamento;
        this.gerenciarAgendamentoService.atualizarStatus('EDITAR');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });
  }

  imprimirAgendamento(agendamento: Agendamento): void {
    this.agendamentoService.imprimirComprovante(agendamento.id, this.carregar).subscribe(pdf => {
      const nav = (window.navigator as any);

      if (nav && nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(pdf);
      } else {
        const objectUrl = URL.createObjectURL(pdf);
        window.open(objectUrl);
      }
    });
  }

  cancelar(id: number): any {
    this.mensagemService.avisoMensagemCondicional('Essa ação não poderá ser desfeita', 'Deseja cancelar o Agendamento?', 'warning').then((result) => {
      if (result.isConfirmed) {
        this.agendamentoService.cancelar(id, this.carregar).subscribe(() => {
          Swal.fire(
            'Atenção!',
            'Seu agendamento foi cancelado',
            'success'
          ).then((response) => {
            if (response.isConfirmed) {
              this.router.navigate(['/']);
            }
          });
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    }, (error) => {
      return this.mensagemService.avisoMensagemError(error)
    });
  }

}
